
<template>
  <div class="container">
<!--    <el-tabs  tab-position="left">-->
<!--      <el-tab-pane  class="margin-left:-40px" label="">-->
    <div>
        <user-claim-manager></user-claim-manager>
<!--      </el-tab-pane>-->
<!--    </el-tabs>-->
    </div>
  </div>
</template>
<script>
import UserClaimManager from './group/UserClaimManager';

import { Tabs,
  TabPane} from 'element-ui';

export default {
  name:"wxcadmin-index",
  components:{
    UserClaimManager,
    // [Tabs.name]:Tabs,
    // [TabPane.name]:TabPane
  }
}
</script>
<style>
</style>